import { ActionError, PromisifiedActionMeta } from 'Interfaces/ActionCreators';
import {
  IntegrationActionPayload,
  IntegrationAuthTokenPayload,
  IntegrationDeactivatePayload,
  IntegrationUrlPayload,
} from 'Interfaces/Integration';
import { createAsyncAction } from 'typesafe-actions';
import { promisifyAsyncAction } from 'Utils/functions';

import {
  IntegrationAuthTokenGetActionTypes,
  IntegrationAuthUrlGetActionTypes,
  IntegrationDeactivateActionTypes,
} from './actionTypes';

export const getAuthUrl = createAsyncAction(
  IntegrationAuthUrlGetActionTypes.request,
  IntegrationAuthUrlGetActionTypes.success,
  IntegrationAuthUrlGetActionTypes.failure,
  IntegrationAuthUrlGetActionTypes.cancel,
)<
  [IntegrationActionPayload, PromisifiedActionMeta],
  [IntegrationUrlPayload, PromisifiedActionMeta],
  [ActionError, PromisifiedActionMeta],
  [undefined, PromisifiedActionMeta]
>();

export const $getAuthUrl = promisifyAsyncAction(getAuthUrl);

export const getAuthToken = createAsyncAction(
  IntegrationAuthTokenGetActionTypes.request,
  IntegrationAuthTokenGetActionTypes.success,
  IntegrationAuthTokenGetActionTypes.failure,
  IntegrationAuthTokenGetActionTypes.cancel,
)<
  [IntegrationActionPayload, PromisifiedActionMeta],
  [IntegrationAuthTokenPayload, PromisifiedActionMeta],
  [ActionError, PromisifiedActionMeta],
  [undefined, PromisifiedActionMeta]
>();

export const $getAuthToken = promisifyAsyncAction(getAuthToken);

export const deactivate = createAsyncAction(
  IntegrationDeactivateActionTypes.request,
  IntegrationDeactivateActionTypes.success,
  IntegrationDeactivateActionTypes.failure,
  IntegrationDeactivateActionTypes.cancel,
)<
  [IntegrationActionPayload, PromisifiedActionMeta],
  [IntegrationDeactivatePayload, PromisifiedActionMeta],
  [ActionError, PromisifiedActionMeta],
  [undefined, PromisifiedActionMeta]
>();

export const $deactivate = promisifyAsyncAction(deactivate);
